import { Theme } from "@mui/material/styles";
import { SystemStyleObject } from "@mui/system";

const animation3dViewStyles = {
  wrapper: (theme: Theme): SystemStyleObject<Theme> => ({
    height: "100%",
    width: "100%",
    borderRadius: 0,
    position: "relative",
    display: "flex",
    alignItems: "center",

    [theme.breakpoints.up("md")]: {
      alignItems: "start",
    },
  }),
  animationClass: (): SystemStyleObject<Theme> => ({
    width: "100%",
    height: "100%",
    border: "0",
  }),
};

export default animation3dViewStyles;
